import React, { useState } from 'react';
import { lightThemeName, darkThemeName } from 'theme';

export const ThemeContext = React.createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(lightThemeName);
  const setLightTheme = () => { setTheme(lightThemeName); };
  const setDarkTheme = () => { setTheme(darkThemeName); };

  return (
    <ThemeContext.Provider
      value={{ 
        theme,
        setLightTheme,
        setDarkTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const withTheme = Component => props => (
  <ThemeContext.Consumer>
    {context => <Component {...props} themeContext={context} />}
  </ThemeContext.Consumer>
);
